// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  background: #ffffff;
  scroll-behavior: smooth;
}
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.container {
  position: relative;
  top: 6rem;
}
.loginForm {
  width: 30%;
}
.notification {
  position: absolute !important;
  display: inline-block;
  left: 0;
  top: 80vh;
  min-width: 90%;
  animation: move 2s;
  animation-direction: normal;
  animation-iteration-count: 1;
  z-index: 9999;
}
@keyframes move {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}
.mainSection {
  width: 100%;
}
.table > tbody {
  cursor: pointer;
}
.addClinic {
  width: 50%;
}
.cliniccoachsearch {
  width: 100%;
}
.cliniccoachsearch > :nth-child(1) {
  width: 45%;
}
.cliniccoachsearch > :nth-child(2) {
  width: 45%;
}
.clinicTitle,
.bottomline {
  border-bottom: 1px solid #d6d9e0;
}
.filesList {
  width: 70%;
}
.adminNewsImage {
  height: 7rem;
  width: 20%;
}
.adminNewsImage > img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.mainSection > .content > ul > li {
  list-style: none;
  cursor: pointer;
}
.adminNewsImageEdit {
  height: 12rem;
  width: 100%;
}
.adminNewsImageEdit > img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.titleText {
  width: 50%;
}
.titleText > form {
  width: 100%;
}
.materialdata {
  width: 40%;
}
.searchAccount {
  width: 100%;
}
.searchAccount > form {
  width: 45%;
  cursor: pointer;
}
.searchAccount > form > .formForm {
  width: 100%;
}
.searchAccount > form > .formForm > .field {
  width: 100%;
}
.searchAccount > .buttons {
  width: 100%;
}

@media screen and (min-width: 768px) {
  .notification {
    min-width: 50%;
  }
}

@media screen and (min-width: 1024px) {
  .notification {
    min-width: 30%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,OAAO;EACP,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;AACf;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["html {\n  background: #ffffff;\n  scroll-behavior: smooth;\n}\nbody {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n.container {\n  position: relative;\n  top: 6rem;\n}\n.loginForm {\n  width: 30%;\n}\n.notification {\n  position: absolute !important;\n  display: inline-block;\n  left: 0;\n  top: 80vh;\n  min-width: 90%;\n  animation: move 2s;\n  animation-direction: normal;\n  animation-iteration-count: 1;\n  z-index: 9999;\n}\n@keyframes move {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n.mainSection {\n  width: 100%;\n}\n.table > tbody {\n  cursor: pointer;\n}\n.addClinic {\n  width: 50%;\n}\n.cliniccoachsearch {\n  width: 100%;\n}\n.cliniccoachsearch > :nth-child(1) {\n  width: 45%;\n}\n.cliniccoachsearch > :nth-child(2) {\n  width: 45%;\n}\n.clinicTitle,\n.bottomline {\n  border-bottom: 1px solid #d6d9e0;\n}\n.filesList {\n  width: 70%;\n}\n.adminNewsImage {\n  height: 7rem;\n  width: 20%;\n}\n.adminNewsImage > img {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n}\n.mainSection > .content > ul > li {\n  list-style: none;\n  cursor: pointer;\n}\n.adminNewsImageEdit {\n  height: 12rem;\n  width: 100%;\n}\n.adminNewsImageEdit > img {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n}\n.titleText {\n  width: 50%;\n}\n.titleText > form {\n  width: 100%;\n}\n.materialdata {\n  width: 40%;\n}\n.searchAccount {\n  width: 100%;\n}\n.searchAccount > form {\n  width: 45%;\n  cursor: pointer;\n}\n.searchAccount > form > .formForm {\n  width: 100%;\n}\n.searchAccount > form > .formForm > .field {\n  width: 100%;\n}\n.searchAccount > .buttons {\n  width: 100%;\n}\n\n@media screen and (min-width: 768px) {\n  .notification {\n    min-width: 50%;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .notification {\n    min-width: 30%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
